import { useMemo } from 'react';

import { FarmEventItem } from '@/pages/TaskTablet/components/farmEventItem/FarmEventItem';
import { EventProtocol } from '@/pages/Vaccination/components/task/types';
import { UUID } from '@/shared/api/types';
import { getNameFromEventProtocols } from '@/utils/task';

import cl from './styles.module.scss';

interface FarmProps {
  events: EventProtocol[];
  structuralDivisionId: UUID;
  isTransformData: boolean;
  duplicateInventoryNumbers: Set<string>;
  onInventoryClick?: (value: string) => void;
}

export const Farm = ({
  events,
  structuralDivisionId,
  isTransformData,
  duplicateInventoryNumbers,
  onInventoryClick,
}: FarmProps) => {
  const structuralDivisionName = useMemo(
    () => getNameFromEventProtocols(events),
    [events],
  );

  return (
    <div className={cl.wrap}>
      <div className={cl.title}>{structuralDivisionName}</div>
      {events.map((event) => (
        <FarmEventItem
          {...event}
          key={event.id}
          isTransformData={isTransformData}
          duplicateInventoryNumbers={duplicateInventoryNumbers}
          onInventoryClick={onInventoryClick}
        />
      ))}
    </div>
  );
};
